import { Component, ErrorInfo, ReactNode } from 'react';

import { notify } from 'common/util/Notifier';

interface Props {
    children: ReactNode;
}

export class ErrorBoundary extends Component<Props> {
    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        // Doesn't catch uncaught promise rejections
        // errorInfo.componentStack gives the component stack as string
        // error.message gives error message
        // error.stack gives complied js stack
        // error.name gives the kind of error TypeError etc
        notify({ error: error.message, stack: error.stack });
    }

    render(): ReactNode {
        const { children } = this.props;

        return children;
    }
}
